import * as _yup from 'yup'
import {yup_locale_cs} from './translate/yup_cs'

_yup.setLocale(yup_locale_cs)

export const yup = _yup;